import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class SpringSacred1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.SPRING_SACRED1;
}

export default SpringSacred1PoiTileEntity;
